"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var assets = _interopRequireWildcard(require("./domains/assets"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _assets$actions = assets.actions,
  updateAssetLabels = _assets$actions.updateLabels,
  updateAssetCategory = _assets$actions.updateAssetCategory,
  removeAssetCategory = _assets$actions.removeAssetCategory,
  deprecateAsset = _assets$actions.deprecateAsset,
  revertDeprecateAsset = _assets$actions.revertDeprecateAsset,
  deleteAsset = _assets$actions.deleteAsset,
  getAsset = _assets$actions.getAsset,
  updateAssetMetadata = _assets$actions.updateAssetMetadata,
  updateAssetName = _assets$actions.updateName,
  updateAssetContactName = _assets$actions.updateContactName,
  updateAssetContactEmail = _assets$actions.updateContactEmail,
  updateAssetStatus = _assets$actions.updateStatus,
  updateAssetIcon = _assets$actions.updateIcon,
  deleteAssetIcon = _assets$actions.deleteIcon,
  updateAssetDescription = _assets$actions.updateDescription,
  getAssetVersionsDependencies = _assets$actions.getVersionsDependencies,
  getAssetVersionsDependents = _assets$actions.getVersionsDependents,
  getAssetVersionGroups = _assets$actions.getVersionGroups,
  getAssetMinorVersions = _assets$actions.getMinorVersions,
  updateAssetVisibility = _assets$actions.updateVisibility,
  getLifecycleStateActions = _assets$actions.getLifecycleStateActions,
  updateMinorVersions = _assets$actions.updateMinorVersions;
var _assets$selectors = assets.selectors,
  selectAssetVersions = _assets$selectors.assetVersions,
  selectIsAssetMinorDeprecated = _assets$selectors.isMinorDeprecated,
  selectIsAssetMinorPublished = _assets$selectors.isMinorPublished,
  selectAsset = _assets$selectors.asset,
  selectAssetVersionsDependencies = _assets$selectors.assetVersionsDependencies,
  selectAssetVersionsDependents = _assets$selectors.assetVersionsDependents,
  selectAssetMinorVersions = _assets$selectors.assetMinorVersions,
  selectAssetVersionGroups = _assets$selectors.assetVersionGroups,
  selectCanEditAsset = _assets$selectors.canEdit,
  selectCanAdminAsset = _assets$selectors.canAdmin;
var actions = {
  updateAssetLabels: updateAssetLabels,
  updateAssetCategory: updateAssetCategory,
  removeAssetCategory: removeAssetCategory,
  deprecateAsset: deprecateAsset,
  revertDeprecateAsset: revertDeprecateAsset,
  deleteAsset: deleteAsset,
  getAsset: getAsset,
  updateAssetMetadata: updateAssetMetadata,
  updateAssetName: updateAssetName,
  updateAssetContactName: updateAssetContactName,
  updateAssetContactEmail: updateAssetContactEmail,
  updateAssetStatus: updateAssetStatus,
  updateAssetIcon: updateAssetIcon,
  deleteAssetIcon: deleteAssetIcon,
  updateAssetDescription: updateAssetDescription,
  getAssetVersionsDependencies: getAssetVersionsDependencies,
  getAssetVersionsDependents: getAssetVersionsDependents,
  getAssetVersionGroups: getAssetVersionGroups,
  getAssetMinorVersions: getAssetMinorVersions,
  updateAssetVisibility: updateAssetVisibility,
  getLifecycleStateActions: getLifecycleStateActions,
  updateMinorVersions: updateMinorVersions
};
var selectors = {
  selectAssetVersions: selectAssetVersions,
  selectIsAssetMinorDeprecated: selectIsAssetMinorDeprecated,
  selectIsAssetMinorPublished: selectIsAssetMinorPublished,
  selectAsset: selectAsset,
  selectAssetVersionsDependencies: selectAssetVersionsDependencies,
  selectAssetVersionsDependents: selectAssetVersionsDependents,
  selectAssetMinorVersions: selectAssetMinorVersions,
  selectAssetVersionGroups: selectAssetVersionGroups,
  selectCanEditAsset: selectCanEditAsset,
  selectCanAdminAsset: selectCanAdminAsset
};
var _default = exports.default = {
  actions: actions,
  selectors: selectors
};
//# sourceMappingURL=assets.js.map